import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router';

const PrivateRoute = () => {
    const currentUser = useSelector(state => state.auth.currentUserId);
    const location = useLocation();

    if (!currentUser) {
        return <Navigate replace state={{ from: location }} to="/login"/>;
    }

    return (
        <Outlet/>
    );
};

export default PrivateRoute;
